import u from "./ui.module.css";

const VARIANTS = {
  primary: u.btnPrimary,
  secondary: u.btnSecondary,
  ghost: u.btnGhost,
  danger: u.btnDanger,
};

const SIZES = {
  sm: u.btnSm,
  md: u.btnMd,
  lg: u.btnLg,
};

export default function Button({
  children,
  variant = "primary",
  size = "md",
  block = false,
  className = "",
  type = "button",
  ...rest
}) {
  const classes = [
    u.btn,
    VARIANTS[variant] || VARIANTS.primary,
    SIZES[size] || SIZES.md,
    block ? u.btnBlock : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <button type={type} className={classes} {...rest}>
      {children}
    </button>
  );
}
